// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"83119a00","250":"2a1dbf09","407":"564fbb81","424":"7dc10bf0","436":"23a48cd4","453":"f394a27d","455":"2b9dbaca","501":"de910745","595":"be28ec34","606":"e95d597f","691":"d7fbedf8","821":"b7efe1a8","925":"9376ce1f","969":"1721cb8c"}[chunkId] + ".chunk.js";
};